/* eslint-disable react-hooks/exhaustive-deps */
import { PrintTransactionModal } from "components"
import moment from "moment"
import { useList } from "pages/Setup/Preference/SettingCompany/utils"
import { useEffect, useState } from "react"
import { useFormContext } from "react-hook-form"
import {
  convertNumber,
  useCountryById,
  useHandleAuth,
  useProvinceById,
  useRegencyById,
  useSubdistrictById
} from "utils"
import { useSupplier } from "../../components/Supplier/utils"
import { useProduct } from "../../PurchaseOrder/components/DetailBody/utils"
import {
  useEmployeeDetail,
  useSubdomainSetting,
  useVendorDetail
} from "../../PurchaseOrder/utils"
import { FormType } from "../utils"
import { DetailBillType } from "../types"

export function Print(params: {
  approve_by?: string
  created_by?: number
  data?: DetailBillType | null
  trx_code: string
  withImage?: boolean
  toggle: () => void
}): JSX.Element {
  // Form
  const {
    formState: { defaultValues }
  } = useFormContext<FormType>()

  // Hooks
  const product = useProduct()
  const setting = useSubdomainSetting()
  const vendor = useVendorDetail(defaultValues?.vendor_id)
  const createdBy = useEmployeeDetail(params.created_by)
  const company = useList()
  const country = useCountryById()
  const province = useProvinceById()
  const regency = useRegencyById()
  const subdistrict = useSubdistrictById()
  const supplier = useSupplier()
  const { userTokenData } = useHandleAuth()

  // Vars
  const [address, setAddress] = useState<string>("")
  const userToken = userTokenData()
  // const isLoading: boolean = Boolean(
  //   approvedBy.isLoading ||
  //   createdBy.isLoading ||
  //   product.isLoading ||
  //   setting.isLoading ||
  //   taxCode.isReloading ||
  //   vendor.isLoading
  // )

  useEffect(() => {
    if (defaultValues?.vendor_id) {
      product.refetch(defaultValues?.vendor_id)
    }

    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    company.fetchData().then((res) => {
      setAddress(res.address)

      if (res.subdistrict_id) {
        subdistrict.fetchData(res.subdistrict_id)
      }

      if (res.regency_id) {
        regency.fetchData(res.regency_id)
      }

      if (res.province_id) {
        province.fetchData(res.province_id)
      }

      if (res.country_id) {
        country.fetchData(res.country_id)
      }
    })
  }, [])

  // Functions
  const getAddress = (): string => {
    let generateAddress = address ?? ""

    if (subdistrict.data) {
      generateAddress += ", " + subdistrict.data.subdistrict_name
    }

    if (regency.data) {
      generateAddress += ", " + regency.data.regency_name
    }

    if (province.data) {
      generateAddress += ", " + province.data.province_name
    }

    if (country.data) {
      generateAddress += ", " + country.data.country_name
    }

    return generateAddress
  }

  // Functions
  const getVendorAddress = (): string => {
    const data = supplier.data.find(
      (item) => item.value === defaultValues?.vendor_id
    )

    let generateAddress = data?.address ?? ""

    if (data?.subdistrict_name) {
      generateAddress += ", " + data.subdistrict_name
    }

    if (data?.regency_name) {
      generateAddress += ", " + data.regency_name
    }

    if (data?.province_name) {
      generateAddress += ", " + data.province_name
    }

    if (data?.country_name) {
      generateAddress += ", " + data.country_name
    }

    return generateAddress
  }

  return (
    <PrintTransactionModal
      isLoading={
        company.isLoading ||
        supplier.isLoading ||
        country.isLoading ||
        province.isLoading ||
        subdistrict.isLoading ||
        regency.isLoading
      }
      toggle={params.toggle}>
      <section className="flex flex-col gap-3">
        <div className="text-center text-2xl font-bold uppercase">
          {userToken?.company_name}
        </div>

        <section className="grid grid-cols-2 items-stretch gap-1">
          <section className="font-bold">
            <table className="table-top">
              <tbody className="font-bold">
                <tr>
                  <td className="pr-2">ADDRESS</td>
                  <td className="whitespace-nowrap">: {getAddress()}</td>
                </tr>

                <tr>
                  <td>PHONE</td>
                  <td> : {setting.data?.phone ? setting.data?.phone : "-"}</td>
                </tr>

                <tr>
                  <td>EMAIL</td>
                  <td> : {setting.data?.email ? setting.data?.email : "-"}</td>
                </tr>

                <tr>
                  <td>WEBSITE</td>
                  <td>
                    : {setting.data?.website ? setting.data?.website : "-"}
                  </td>
                </tr>
              </tbody>
            </table>
          </section>

          <section className="flex flex-col justify-between items-end">
            <div className="text-2xl font-bold text-right">BILL</div>

            <table>
              <tbody className="font-bold ">
                <tr>
                  <td width={10}>DATE :</td>
                  <td className="whitespace-nowrap text-right">
                    {defaultValues?.transaction_date
                      ? moment(defaultValues?.transaction_date).format(
                          "DD/MM/YYYY"
                        )
                      : "-"}
                  </td>
                </tr>

                <tr>
                  <td width={10} className="whitespace-nowrap">
                    BILL ID#:{" "}
                  </td>
                  <td className="whitespace-nowrap text-right ps-4">
                    {params.trx_code}
                  </td>
                </tr>

                <tr>
                  <td width={10} className="whitespace-nowrap">
                    REF PO ID#:{" "}
                  </td>
                  <td className="whitespace-nowrap text-right ps-4 ">
                    {defaultValues?.po_code}
                  </td>
                </tr>

                <tr>
                  <td width={10} className="whitespace-nowrap">
                    DELIVERY:{" "}
                  </td>
                  <td className="whitespace-nowrap text-right ps-4">
                    {defaultValues?.delivery_no
                      ? `#${defaultValues?.delivery_no}`
                      : "-"}
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
        </section>

        <table className="table table-bordered">
          <tbody>
            <tr className="bg-black text-white font-bold">
              <td colSpan={2}>VENDOR INFORMATION</td>
            </tr>

            <tr>
              <td>
                <div>VENDOR NAME</div>
                <div className="font-bold">{defaultValues?.vendor_name}</div>
              </td>

              <td>
                <div>CREATED BY</div>
                <div className="font-bold">{createdBy.data?.employee_name}</div>
              </td>
            </tr>

            <tr>
              <td colSpan={2}>
                <div>ADDRESS</div>
                <div className="font-bold">{getVendorAddress()}</div>
              </td>
            </tr>

            <tr>
              <td>
                <div>CONTACT NO</div>
                <div className="font-bold">{vendor.data?.handphone}</div>
              </td>

              <td>
                <div>EMAIL ADDRESS</div>
                <div className="font-bold">{vendor.data?.email}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <table className="table table-bordered">
          <thead>
            <tr className="bg-black text-white">
              <th>#</th>
              {params.withImage ? <th>PICTURE</th> : null}
              <th>DESCRIPTION</th>
              <th>BACKORDER</th>
              <th>DELIVERED</th>
              <th>UNIT</th>
            </tr>
          </thead>

          <tbody>
            {defaultValues?.probildetail?.map((item, key) => {
              // Vars
              const productData = product.data.find((i) => i.value === item?.product_id)
              const productFoto = params?.data?.detailbill?.find((i) => i.product_id?.toString() === item?.product_id?.toString())
              const imagePath = `${process.env.REACT_APP_BASE_URL_API}/getimage/?imgpath=${productFoto?.product_foto}`

              return (
                <tr>
                  <td className="text-center">{key + 1}</td>
                  {params.withImage ? (
                    <td width={150}>
                      <img
                        width={150}
                        height={150}
                        src={imagePath}
                        alt={productData?.product_name}
                      />
                    </td>
                  ) : null}
                  <td className="whitespace-nowrap">
                    <div>{productData?.product_barcode}</div>
                    <div className="mb-4">{productData?.product_name}</div>
                    <div>COLOUR : {productData?.mr_product_colour_name}</div>
                    <div>STYLE : {productData?.mr_product_style_name}</div>
                    <div>WEIGHT : {productData?.weight}</div>
                  </td>
                  <td className="text-right">
                    {convertNumber(item?.qty_order ?? 0).intoCurrency}
                  </td>
                  <td className="text-right">
                    {convertNumber(item?.quantity_bill ?? 0).intoCurrency}
                  </td>
                  <td>{productData?.mr_unit_name}</td>
                </tr>
              )
            })}
          </tbody>
        </table>

        <section className="grid grid-cols-5 items-stretch gap-5">
          <section className="col-span-2">
            <table className="table table-bordered">
              <tbody>
                <tr className="bg-black text-white font-bold">
                  <td>Additional Notes:</td>
                </tr>

                <tr className="min-h-[300px]">
                  <td>{defaultValues?.memo}</td>
                </tr>
              </tbody>
            </table>
          </section>
          <div />

          <section className="col-span-2">
            <table className="table table-bordered">
              <tbody>
                <tr className="bg-black text-white font-bold">
                  <td>Received By</td>
                </tr>

                <tr className="h-[100px]"/>
              </tbody>
            </table>
          </section>
        </section>
      </section>
    </PrintTransactionModal>
  )
}
